export default {
  OK: "đồng ý",
  CLOSE: "Tài khoản đã bị đóng !",
  BLOCK: "Tài khoản đã bị khoá !",
  passwordRequired: "Mật khẩu bị bắt buộc !",
  usernameRequired: "Tên đăng nhập bị bắt buộc !",

  session_not_exists: "Phiên hết hạn! Hãy đăng nhập lại để tiếp tục ...",
  session_expired: "Phiên hết hạn! Hãy đăng nhập lại để tiếp tục ...",
  sessionExpired: "Phiên hết hạn! Hãy đăng nhập lại để tiếp tục ...",
  invalidSession: "Phiên hết hạn! Hãy đăng nhập lại để tiếp tục ...",
  accountIdRequired: "Phiên hết hạn! Hãy đăng nhập lại để tiếp tục ...",
  NoUserAccessRight: "Quyền truy cập bị từ chối ! Vui lòng liên hệ cấp trên để được tiếp tục...",
  account_not_exists: "Mật khẩu không hợp lệ.",
  invalid_password: "Mật khẩu không hợp lệ.",
  secondary_account_exists: "Biệt danh của bạn đã được khởi tạo .",
  systemError: "Hệ thống nội bộ lỗi .",
  new_login_id_exists: "Biệt danh không hiệu lực . Vui lòng cài đặt biệt danh khách .",
  loginLimit: "Bạn đã đăng nhập quá thường xuyên, hãy thử lại sau 1 phút ...",
  requestLimit: "Bạn gửi yêu cầu quá nhiều.",
  unableToGetBalanceAtTheMoment: "Lỗi máy chủ nội bộ.",
  oddsDisplayInvalid: "Tỷ lệ hiển thị không hợp lệ.",
  oddsIsUpdating: "Tỷ lệ đang cập nhật ...",
  atLeastTwoMatchToBetParlay: "Phải có ít nhất 2 trận đấu để được cược xiên với nhau .",
  duplicate_debit_record: "Tỷ lệ đang cập nhật ...",

  insufficient_balance: "Số dư không đủ",
  betOverMaxPerMatch: "Phần thầu của bạn đã vượt mức phần thầu tối đa.",
  betOverMax: "Phần thầu của bạn đã vượt mức phần thầu tối đa.",
  betLowerMin: "Phần thầu của bạn ít hơn mức phần thầu tối thiểu.",

  loginFailed: "Đăng nhập không thành công, xin vui lòng thử lại sau...",
  requestFailed: "Kết nối của bạn không ổn định. Vui lòng kiểm tra kết nối của bạn và thử lại.",

  close: "Tài khoản đã bị đóng ! Vui lòng liên hệ cấp trên của bạn để được tiếp tục...",
  suspend: "Tài khoản đã bị treo ! Vui lòng liên hệ cấp trên của bạn để được tiếp tục...",
  freeze: "Tài khoản của bạn đã bị đóng băng ! Vui lòng liên hệ cấp trên của bạn để được tiếp tục...",

  alphaNumOnly: "Chỉ sử dụng chữ và số",

  // vuelidate
  isRequired: "Vui lòng nhập một {fname}.",
  isMinValue: "{fname} phải có tối thiểu {fvalue}.",
  isMaxValue: "{fname} phải nhỏ hơn hoặc bằng {fvalue}.",
  isMinLength: "{fname} phải có ít nhất {fvalue} ký tự.",
  isMaxLength: "{fname} phải nhỏ hơn hoặc bằng {fvalue} ký tự.",
  isAlpha: "{fname} chỉ chấp nhận bảng chữ cái.",
  isAlphaNum: "{fname} chỉ chấp nhận chữ cái và số.",
  isNumeric: "{fname} chỉ chấp nhận numerics.",
  isEmail: "{fname} chấp nhận địa chỉ email hợp lệ.",
  isIpAddress: "{fname} chỉ chấp nhận địa chỉ IPv4 chỉ có giá trị.",
  isSameAs: "{fname} phải được giống như {fname2}.",
  isUrl: "{fname} hỉ chấp nhận URL.",
  containAlphaNum: "{fname} phải có ít nhất một chữ cái và một số.",
  selectOption: "Vui lòng chọn {fname}",
  notSameAs: "{fname} và {fname2} không thể giống nhau.",

  currPasswordRequired: "Mật khẩu hiện tại bắt buộc phải có!",
  newPasswordRequired: "Mật khẩu mới bắt buộc phải có!",
  confirmNewPasswordRequired: "Xác nhận mật khẩu mới bắt buộc phải có!",
  passwordsNotMatch: "Mật khẩu không giống nhau!",
  nickNameRequired: "Biệt danh là bắt buộc phải có!",

  startDateRequired: "Ngày bắt đầu là bắt buộc phải có!",
  endDateRequired: "Ngày kết thúc là bắt buộc phải có!",
  pageSizeRequired: "Kích thước trang là bắt buộc phải có!",
  pageNumberRequired: "Số trang là bắt buộc phải có!",
  sportsTypeRequired: "Loại thể thao là bắt buộc phải có!",

  workingDateRequired: "Ngày hoạt động là bắt buộc phải có!",
  leagueIdRequired: "Tên giải đấu là bắt buộc phải có!",
  isOutrightRequired: "Tên cược vô địch là bắt buộc phải có!",

  maxParlayTicket: "Đạt tối đa các trận đấu trong 1 lần cược xiên!",
  matchHide: "Trận đấu không tồn tại!",
  selectLeague: "Please select at least 1 league"
};
